import React, { useState, useContext, useEffect } from 'react';
import { Button, Box, Typography, useMediaQuery } from '@mui/material';
import { ThemeContext } from '../../../lib/contexts/ThemeContext';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { UserContext } from '../../../lib/contexts/UserContext';
import { getClientHost } from '../../../lib/constants/constants';
import DietQualityBar from '../../../components/DietQualityBar/DietQualityBar';
import { useNavigate } from 'react-router-dom';

const DietQualityGoalCard = ({ dietQualityScore, goalDietQualityScore, date }) => {
  const [showFullReport, setShowFullReport] = useState(false);
  const {
    state: { userObject, lastQuality, goalQuality, workflow_share_url },
  } = useContext(UserContext);
  const navigate = useNavigate();

  const [currentScore, setCurrentScore] = useState(dietQualityScore ?? lastQuality);
  const [goalScore, setGoalScore] = useState(goalDietQualityScore ?? goalQuality);
  const isMobileView = useMediaQuery('(max-width: 600px)');

  useEffect(() => {
    if (dietQualityScore != null) {
      setCurrentScore(dietQualityScore);
    } else if (lastQuality) {
      setCurrentScore(lastQuality);
    }
    if (goalDietQualityScore != null) {
      setGoalScore(goalDietQualityScore);
    } else if (goalQuality) {
      setGoalScore(goalQuality);
    }
    // console.log('here is the userObject in DietQualityGoalCard: ', userObject);
  }, [userObject, lastQuality, goalQuality, dietQualityScore, goalDietQualityScore]);

  // useEffect(() => {
  //     console.log('currentScore is in DietQualityGoalCard: ', currentScore);
  //     console.log('goalScore is in DietQualityGoalCard: ', goalScore);
  // }, [currentScore, goalScore]);

  const handleViewFullReport = () => {
    navigate('/quality');
  };

  const handleTakeAssessment = () => {
    const assessmentUrl = `${getClientHost()}/assessment/start`;
    // console.log('this is getClientHost: ', getClientHost());
    window.open(assessmentUrl, '_blank');
  };

  // if (currentScore === undefined && goalScore === undefined) {
  //     throw new Error("Either currentScore or goalScore must be provided.");
  // }
  const {
    state: { darkMode },
  } = useContext(ThemeContext);

  const getTitle = () => {
    if (currentScore !== undefined && goalScore !== undefined) {
      return 'Your Diet Quality';
    } else if (currentScore !== undefined) {
      return 'Your Diet Quality';
    } else if (goalScore !== undefined) {
      return 'Goal Diet Quality';
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '325px',
        height: isMobileView ? '210px' : '170px',
        padding: '16px 0px 16px 0px',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: '8px',
        gap: '13px',
      }}
    >
      <Box
        id="scale-header"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '14px',
          alignSelf: 'stretch',
        }}
      >
        <Box
          id="scale-container"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '14px',
            alignSelf: 'stretch',
          }}
        >
          <Typography
            sx={{
              // color: 'var(--Gray-gray12, #171717)',
              // leadingTrim: 'both',
              // textEdge: 'cap',
              // fontFamily: 'Montserrat',
              // fontSize: '16px',
              // fontStyle: 'normal',
              // fontWeight: 400,
              // lineHeight: 'normal',
              // color: order.status === 'Future' ? 'white' : 'var(--Gray-gray12, #171717)',
              leadingTrim: 'both',
              textEdge: 'cap',
              fontFamily: 'Montserrat',
              fontSize: '18px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: 'normal',
            }}
          >
            {getTitle()}
          </Typography>
          {goalScore === null && currentScore === null && (
            <Typography
              sx={{
                color: 'var(--color12, #1C124D)',
                textAlign: 'center',
                leadingTrim: 'both',
                textEdge: 'cap',
                fontFamily: 'Montserrat',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: 'normal',
              }}
            >
              Pending Diet ID Assessment
            </Typography>
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '16px',
              alignSelf: 'stretch',
              borderRadius: '12px',
              background: '#FFF',
            }}
          >
            <DietQualityBar
              currentScore={currentScore}
              goalScore={goalScore}
            />
          </Box>
        </Box>
      </Box>
      <Button
        sx={{
          display: 'flex',
          width: '245px',
          height: 'var(--3, 36px)',
          padding: 'var(--0, 0px) var(--3, 13px)',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 'var(--3, 13px)',
          flexShrink: 0,
          borderRadius: 'var(--3, 7px)',
          border: 'var(--1, 2px) solid var(--color12, #1C124D)',
          background: 'var(--color1, #FDFDFD)',
        }}
        onClick={handleViewFullReport}
      >
        <Typography
          sx={{
            color: 'var(--color12, #1C124D)',
            textAlign: 'center',
            leadingTrim: 'both',
            textEdge: 'cap',
            fontFamily: 'Montserrat',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
          }}
        >
          View Full Report
        </Typography>
        <VisibilityIcon
          style={{
            width: 'var(--1, 20px)',
            height: 'var(--1, 20px)',
            flexShrink: 0,
          }}
        />
      </Button>
      {isMobileView && (
        <Button
          sx={{
            display: 'flex',
            width: '245px',
            height: 'var(--3, 36px)',
            padding: 'var(--0, 0px) var(--3, 13px)',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 'var(--3, 13px)',
            flexShrink: 0,
            borderRadius: 'var(--3, 7px)',
            border: '1px solid var(--color12, #1C124D)',
            background: 'var(--color12, #1C124D)',
          }}
          onClick={handleTakeAssessment}
        >
          <Typography
            sx={{
              color: 'var(--color1, #FDFDFD)',
              textAlign: 'center',
              leadingTrim: 'both',
              textEdge: 'cap',
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: 'normal',
            }}
          >
            Re-assess Your Diet
          </Typography>
        </Button>
      )}
    </Box>
  );
};

export default DietQualityGoalCard;
